"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceVariant = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const FlightSeatCount_1 = require("../../Flight/List/FlightSeatCount");
const Tooltip_1 = require("../../Tooltip");
const rateTypeMapper_1 = require("./rateTypeMapper");
require("./index.scss");
const className = 'price-variant';
const PriceVariant = (props) => {
    var _a;
    const { isDisabled, isDetailsOpen, isSelected, modificators, onClick, positionNumber, price, rateTariffType = 'economy', count, allowedPriceWithSoldOut, allowedNegativeCount, } = props;
    const title = props.title || ((_a = rateTypeMapper_1.rateTypeConfigMap[rateTariffType]) === null || _a === void 0 ? void 0 : _a.title);
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        rateTariffType ? rateTypeMapper_1.rateTypeToModifierMap[rateTariffType] : undefined,
        isSelected ? 'selected' : undefined,
        isDetailsOpen ? 'with-details' : undefined,
        isDisabled ? 'disabled' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: classNames, onClick: () => {
            if (isDisabled)
                return;
            onClick(positionNumber);
        } },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", { className: `${className}__header` },
                react_1.default.createElement("div", { className: `${className}__title` }, title),
                react_1.default.createElement(Tooltip_1.Tooltip, { text: count > 0 ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant:Count', defaultMessage: '{count} seats available', values: { count } })) : undefined, modificators: 'white' },
                    react_1.default.createElement("p", { className: `${className}__count` },
                        react_1.default.createElement(FlightSeatCount_1.FlightSeatCount, { value: count, allowedNegative: allowedNegativeCount })))),
            react_1.default.createElement("div", { className: `${className}__price` },
                react_1.default.createElement("span", { className: `${className}__price-info` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant:PriceInfo', defaultMessage: 'p.P.' })),
                react_1.default.createElement("span", null,
                    "CHF ",
                    (allowedPriceWithSoldOut || count > 0) ? price : '-'))),
        react_1.default.createElement("div", { className: `${className}__bar` },
            react_1.default.createElement("div", null))));
};
exports.PriceVariant = PriceVariant;
//# sourceMappingURL=index.js.map